<template>
    <v-row  no-gutters>
        <router-view/>
        <map-component
                select
                :height="getHeight"
                mark
                :selectLayers="['comments', 'adminRoutes']"
                @toggle-assessor-route="toggleLayer('adminRoutes')"
                @toggle-candidate-route="toggleLayer('drawnRoutes')"
                @toggle-comments="toggleLayer('commentsLayer')"
                @go-home="handleGoHome"
                @map-created="handleMapCreated"></map-component>
    </v-row>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import MapComponent from '../Map.vue'
  import GeoJSON from "ol/format/GeoJSON.js";
  import {buffer} from "ol/extent";

  export default {
    name: 'AnswerMap',

    components: {
      MapComponent
    },

    computed: {
      ...mapGetters({
        ICONS: 'getIcons',
        ASSESSMENT: 'GET_SELECTED_ASSESSMENT',
        ANSWER_DATA: 'GET_ANSWER_DATA'
      }),
      getHeight() {
        let windowHeight = document.body.offsetHeight;
        let offset = 120;

        return `${windowHeight - offset}px`
      }
    },

    /*    mounted () {
          if (!this.ANSWER_DATA.candidate){
            alert("There is no candidate data")
          }
        },*/

    data() {
      return {
        commentStyle: null,
        drawnRoutes: null,
        candidateStartPoint: null,
        adminRoutes: null
      }
    },

    methods: {
      ...mapActions(['MARK_FETCH_ANSWER_DATA']),
      handleMapCreated(map) {
        this.map = map;
        this.createLayer();
      },
      toggleLayer(layer) {
        this[layer].setVisible(!this[layer].getVisible());
      },
      handleGoHome() {
        var src = this.pointsLayer.getSource();
        if (src.getFeatures().length > 1) {
          this.map.setExtent(buffer(this.pointsLayer.getSource().getExtent(), 250));
        } else {
          this.map.setExtent(this.pointsLayer.getSource().getExtent(), 10);
        }
      },
      createLayer() {
        let geoJSON;
        let style = new GOX.Style();
        let JSONStyle = style.JSONtoStyle({
          image: {
            src: require('../../../assets/icons/' + this.ICONS.comment),
            anchor: [0, 23],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels'
          }
        });
        this.commentStyle = JSONStyle;

        //set up and fetch the start and end points and add them to their own layer.
        this.pointsLayer = new GOX.Layer.Vector({
          id: 'points',
          geometry: 'Point',
          zIndex: 100
        });
        this.map.addLayer(this.pointsLayer);
        this.drawPoints();

        //set up and fetch the start and end points and add them to their own layer.
        this.commentsLayer = new GOX.Layer.Vector({
          id: 'comments',
          geometry: 'Point',
          zIndex: 100
        });
        this.map.addLayer(this.commentsLayer);
        this.drawComments();

        //set up the routes layer and add it to the map
        this.drawnRoutes = new GOX.Layer.Vector({
          id: 'assesse-routes',
          geometry: 'LineString',
          zIndex: 10,
        });
        this.map.addLayer(this.drawnRoutes);

        if (this.ANSWER_DATA.candidate){
          this.drawAnswer('drawnRoutes', this.ANSWER_DATA.candidate, {color: 'blue', dash: [5,5]});
        }

        //Set up a layer to show the candidate start point
        this.candidateStartPoint = new GOX.Layer.Vector({
          id: 'assessee-start',
          geometry: 'point',
          zIndex: 101
        });

        this.map.addLayer(this.candidateStartPoint);
        this.getCandidateStartPoints();

        //set up the routes layer and add it to the map
        this.adminRoutes = new GOX.Layer.Vector({
          id: 'admin-routes',
          geometry: 'LineString',
          zIndex: 3
        });
        this.map.addLayer(this.adminRoutes);
        this.drawAssessorRoutes();

        //this.drawLayer.startDrawing();
      },
      drawAssessorRoutes() {
        this.ANSWER_DATA.assessor.routes.forEach((route) => {
          console.log("DRAW: ")
          console.log(route.geoJSON)
          this.drawAnswer('adminRoutes', route.geoJSON, {color: route.colour, value: route.value});
        })
      },
      drawPoints() {
        let startPoint = this.ANSWER_DATA.assessor.startpoint;

        let style1 = new GOX.Style();
        let startStyle = style1.JSONtoStyle({
          image: {
            src: require('../../../assets/icons/' + this.ICONS.start),
            anchor: [0.5, 48],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels'
          }
        });
        let style2 = new GOX.Style()
        let endStyle = style2.JSONtoStyle({
          image: {
            src: require('../../../assets/icons/' + this.ICONS.end),
            anchor: [0.5, 48],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels'
          }
        });

        var features = new GeoJSON().readFeatures(startPoint, {
          dataProjection: 'EPSG:27700',
          featureProjection: 'EPSG:27700'
        });

        features.forEach((feature) => {
          feature.setStyle(startStyle);
        });

        this.pointsLayer.getSource().addFeatures(features);

        let endPoint = this.ANSWER_DATA.assessor.endpoint;
        var features = new GeoJSON().readFeatures(endPoint, {
          dataProjection: 'EPSG:27700',
          featureProjection: 'EPSG:27700'
        });

        features.forEach((feature) => {
          feature.setStyle(endStyle);
        });

        this.pointsLayer.getSource().addFeatures(features);
        let initialExt = this.pointsLayer.getFeaturesExtent();
        let bufferedExt = buffer(this.pointsLayer.getFeaturesExtent(), 150);
        console.log(initialExt)
        console.log(bufferedExt)
        this.map.setExtent(bufferedExt);
      },
      drawComments() {
        let comments = this.ANSWER_DATA.assessor.comments;

        comments.forEach((comment) => {
          let commentFeature = new GOX.Feature.Point();
          let commentGeometry = commentFeature.getGeometry();

          if (comment.geoJSON) {
            let parsed = JSON.parse(comment.geoJSON);
            console.log(parsed);
            commentGeometry.setCoordinates(parsed.geometry.coordinates);
          } else {
            if (comment.coordinates)
              commentGeometry.setCoordinates(comment.coordinates);
          }

          //commentGeometry.setCoordinates(comment.coordinates);

          if (commentGeometry.flatCoordinates){
            console.dir(commentGeometry)
            commentFeature.setGeometry(commentGeometry);

            commentFeature.setStyle(this.commentStyle);
            commentFeature.set('text', comment.text)
            commentFeature.set('idnr', comment.idnr)

            this.commentsLayer.getSource().addFeature(commentFeature);
          }

        });

        /*        comments.forEach((comment) => {
                  var features = new GOX.Format.GeoJSON().readFeatures(comment.geoJSON, {
                    dataProjection: 'EPSG:27700',
                    featureProjection: 'EPSG:27700'
                  });

                  features.forEach((feature) => {
                    feature.setStyle(this.commentStyle);
                  });
                  this.commentsLayer.getSource().addFeatures(features);
                });*/
      },
      drawAnswer(layer, data, {color, value, dash}) {
        console.log(data)
        var features = new GeoJSON().readFeatures(data, {
          dataProjection: 'EPSG:27700',
          featureProjection: 'EPSG:27700'
        });

        let styleCon = new GOX.Style();
        var styleObject = {
          stroke: {
            width: 6,
            color: color || 'red',
          }
        };

        var style = styleCon.JSONtoStyle(styleObject);
        var styleObject2 = {
          stroke: {
            width: 3,
            color: 'white',
            lineDash: dash || [0, 0]
          }
        };

        features.forEach((feature) => {
          if (layer === 'adminRoutes') {
            styleObject2.text = {
              overflow: true,
              repeat: true,
              color: 'black',
              stroke: {
                color: 'white',
                width: 2
              },
              size: 25,
              weight: 'bold',
              placement: 'line'
            };

          }
          let style2Con = new GOX.Style();
          var style2 = style2Con.JSONtoStyle(styleObject2, feature, value);
          feature.setStyle([style, style2])
        })
        this[layer].getSource().addFeatures(features);
        this.map.setExtent(buffer(this[layer].getFeaturesExtent(), 150));

      },
      getCandidateStartPoints() {
        //Set up a point from the first point in the coord string
        let coords = this.drawnRoutes.getSource().getFeatures()[0].getGeometry().getCoordinates();
      /*  let geomToAdd = new GOX.Geom.Point();
        let coordsToAdd = coords[0];*/
        let thePoint = new GOX.Feature.Point();
        thePoint.getGeometry().setCoordinates(coords[0]);
        //thePoint.setGeometry(geomToAdd);
        this.candidateStartPoint.getSource().addFeature(thePoint);

        //Set the layer style
        let theStyle = new GOX.Style().JSONtoStyle({
          image: {
            src: require('../../../assets/icons/' + this.ICONS.candidateStart),
            anchor: [12, 12],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels'
          }
        });

        console.dir(theStyle)
        this.candidateStartPoint.setStyle(theStyle)

      },
      handleQuestionSelect(question) {
        console.log(question['odata.mediaReadLink'])
        this.MARK_FETCH_ANSWER_DATA(question['odata.mediaReadLink']);
      },
      handleBack() {
        this.$router.go(-1)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
